import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, DataTable, Pill } from "../components/Table";

const ST = { active: "#34C759", no_network: "#FF9500", suspended: "#FF3B30" };

export default function Sims() {
  const [sims, setSims] = useState([]);
  useEffect(() => { api.get("/sims").then((r) => setSims(r.data.sims)); }, []);

  const columns = [
    { key: "iccid", header: "ICCID", render: (r) => <span className="font-mono text-xs">{r.iccid}</span> },
    { key: "mobile", header: "Mobile", render: (r) => <span className="font-mono text-xs">{r.mobile}</span> },
    { key: "operator", header: "Operator", render: (r) => <span className="font-semibold">{r.operator}</span> },
    { key: "data_used_mb", header: "Data Used", render: (r) => `${r.data_used_mb} MB` },
    { key: "expiry", header: "Expiry" },
    { key: "status", header: "Status", render: (r) => <Pill color={ST[r.status]}>{r.status.replace("_", " ")}</Pill> },
  ];

  return (
    <div className="p-5 space-y-4">
      <PageHeader title="SIM Management" subtitle={`${sims.length} SIMs in lifecycle`} />
      <DataTable testid="sims-table" columns={columns} rows={sims} />
    </div>
  );
}
